import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ImportExportFiles from './ImportExportFiles';
import ImportExportWholeProject from './ImportExportWholeProject';

export default class ImportExportTabSettings extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/import-export";
            var path1 = window.origin + "/platform/projectmgmt/import-export/";
            if (currentPath === path || currentPath === path1) {
                $("#import-export-subtab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/import-export/content')) {
                $("#import-export-content").addClass('active');
            } $("#import-export-subtab, #import-export-content")
                .on("click", function () {
                    $("#import-export-subtab, #import-export-content")
                        .removeClass('active');
                    localStorage.setItem("last-used-team-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="./assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/import-export" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="import-export-subtab">
                                        Import/Export Whole Project
                                    </li>
                                </Link>
                                <Link className="nav-item" data-toggle="tab" to="/projectmgmt/import-export/content" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="import-export-content">
                                        Import/Export Content
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/import-export/content" component={ImportExportFiles}></Route>
                    <Route path="/projectmgmt/import-export" component={ImportExportWholeProject}></Route>
                </Switch>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/importExport/ImportExportTabSettings.js